// Custom hook para la carga y gestion de negocios
// Incluye la logica de fetching, estados de carga y errores
import { useState, useEffect, useRef } from 'react'; // <-- Importa useRef
import { toast } from 'react-toastify';
import { useUnidades } from './test/useUnidades';

export const useNegocios = () => {
    const [negocios, setNegocios] = useState([]);
    const [isLoadingNegocios, setIsLoadingNegocios] = useState(true);
    const [errorNegocios, setErrorNegocios] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(0);

    const { getNegocios } = useUnidades();
    // Usa useRef para almacenar la función getNegocios de forma estable
    const getNegociosRef = useRef(getNegocios);

    // Actualiza la referencia si getNegocios cambia (lo hará en cada render, pero el efecto no se re-ejecutará por esto)
    useEffect(() => {
        getNegociosRef.current = getNegocios;
    }, [getNegocios]); // <-- Este useEffect solo actualiza la referencia

    useEffect(() => {
        const fetchNegocios = async () => {
            setIsLoadingNegocios(true);
            setErrorNegocios(null);
            try {
                // console.log("[useNegocios] Intentando cargar Negocios...");
                // Llama a la función a través de la referencia estable
                const negociosResp = await getNegociosRef.current();
                // console.log("[useNegocios] Respuesta de Negocios:", negociosResp);

                if (negociosResp.ok) {
                    setNegocios(negociosResp.negocios || []); // Añadido fallback a [] por seguridad
                    // console.log("[useNegocios] Negocios cargados:", negociosResp.negocios);
                } else {
                    const errorMessage = negociosResp.message || "No se encontraron negocios";
                    toast.error(errorMessage);
                    console.error("[useNegocios] (!ok) Error al cargar negocios:", errorMessage);
                    setErrorNegocios(new Error(errorMessage));
                    setNegocios([]);
                }
            } catch (error) {
                console.error("[useNegocios] Error al cargar negocios:", error);
                const errorMessage = "Ocurrió un error al cargar los negocios.";
                toast.error(errorMessage);
                setErrorNegocios(new Error(errorMessage));
                setNegocios([]);
            } finally {
                setIsLoadingNegocios(false);
                // console.log("[useNegocios] Finalizada la carga de negocios.");
            }
        };
        // Dependencias: ahora solo 'reloadTrigger'. getNegociosRef no es una dependencia porque su .current no cambia
        fetchNegocios();
    }, [reloadTrigger]); // <-- getNegocios se ha eliminado de las dependencias.

    const reloadNegocios = () => {
        setReloadTrigger(prev => prev + 1);
    };

    return {
        negocios,
        isLoadingNegocios,
        errorNegocios,
        reloadNegocios,
    };
};